import { get, set } from "@ember/object"
import { guidFor } from "@ember/object/internals"
import Mixin from "@ember/object/mixin"
import { inject as service } from "@ember/service"
import { isNone } from "@ember/utils"
import _ from "lodash"

export default Mixin.create({
  store: service("ember-store"),
  session: service(),
  appState: service(),

  init(attrs) {
    this._super(...arguments)
    this._registerComponent()
  },

  _registerComponent() {
    // Only register if we give a name. I think this should change, actually
    if (isNone(get(this, "componentId"))) throw Error("No componentId given " + this.toString())

    // Only register component once
    if (this.registeredComponent) return
    else this.registeredComponent = true

    // Construct the id we'll use to identify this
    // let componentStateId = constructComponentStateId(this, get(attrs,'newAttrs.componentId.value'))
    let componentStateId = get(this, "componentId")

    if (_.includes(componentStateId, "undefined")) {
      console.log(
        "It looks like a property you were looking for wasn't definied as you have the word 'undefined' is in your componentId: " +
          componentStateId
      )
    }

    let as = get(this, "store").findInMemory("app-state", get(this, "session.id"))
    if (as !== undefined) {
      let cs = get(as, "attributes." + componentStateId)
      // if (!isNone(cs)) throw Error("Duplicate component state: " + componentStateId);
      // Might be an error?
      // if (!isNone(cs)) console.log("Duplicate component state: " + componentStateId);
    }

    // Register the component
    // let state = JSON.parse(JSON.stringify(get(this, 'defaultState') || {}))
    let state = Object.assign({}, get(this, "defaultState"), {
      componentId: get(this, "componentId"),
    })
    guidFor(state)

    // Set the state of the component - should be the default state initially
    let appState = get(this, "store").findInMemory("app-state", get(this, "appState.id"))
    let componentState = get(appState, `attributes.${componentStateId}`)
    if (isNone(componentState)) {
      set(appState, `attributes.${componentStateId}`, state)
    }
    set(this, "state", get(appState, `attributes.${componentStateId}`))
  },

  // We have to register a component if it's componentId changes
  didUpdateAttrs() {
    this._super(...arguments)
    if (get(this, "componentId") && this._oldComponentId !== get(this, "componentId")) {
      this.registeredComponent = false
      this._registerComponent()
      this.set("_oldComponentId", get(this, "componentId"))
    }
  },

  willDestroyElement() {
    this._super(...arguments)

    // Get the component's state id
    let componentStateId = get(this, "componentId")
    let appState = get(this, "store").findInMemory("app-state", get(this, "appState.id"))
    set(appState, `attributes.${componentStateId}`, null)

    // Deregister the component
    // get(this, 'store').dispatch("DEREGISTER_COMPONENT", {
    //   sessionId:   get(this, 'appState.id'),
    //   componentId: componentStateId,
    // })
  },
})
